import HttpService from '../../infra/http/AxiosConfig'
import CancelablePromise from '../../functions/CancelablePromise';

import { ProductTypesEnum } from '../../Enum/ProductTypesEnum';

const resource = 'revendas'

const formToApiRequest = value => ({
  idOrganizacao: value.organizationId,
  criarOrganizacao: value.createOrganization,
  podeAceitar: value.canAccept,
  podeRejeitar: value.canReject,
  podeCancelar: value.canCancel,
  id: value.id,
  nomeFantasia: value.fantasyName,
  razaoSocial: value.socialReason,
  email: value.email,
  cnpj: value.cnpj,
  endereco: `${value.street}, ${value.neighborhood}, ${value.city} - ${value.state}`,
  cep: value.cep,
  numero: value.number,
  senha: value.password,
  logotipo: value.photo ? value.photo.split(',')[1] : null,
  telefone: value.phone,
  celular: value.cellPhone,
  area: value.area ? value.area.map(a => ({latitude: a.lat, longitude: a.lng})) : [],
  escala: {
    dias: value.workSchedule
      ? value.workSchedule.map(ws => ({
        diaDaSemana: ws.day,
        inicio: ws.start,
        fim: ws.end,
        descricao: ws.name,
        trabalha: ws.works
      }))
      : []
  }
})

const apiRequestToForm = resale => {
  let paths = []

  if (resale.area)
    paths = resale.area.map(a => ({ "lat": a.latitude, "lng": a.longitude}))
  else {
    const createCoordinate = (lat, lng) => ({ "lat": lat, "lng": lng})
    const dimension = 0.001
    let initLat = resale.latitude - (dimension / 2)
    let initLng = resale.longitude + (dimension / 2)
    paths.push(createCoordinate(initLat, initLng))
    paths.push(createCoordinate(initLat + dimension, initLng))
    paths.push(createCoordinate(initLat + dimension, initLng - dimension))
    paths.push(createCoordinate(initLat, initLng - dimension))
  }

  return ({
    organizationId: resale.idOrganizacao,
    canAccept: resale.podeAceitar ? 1 : 0,
    canReject: resale.podeRejeitar ? 1 : 0,
    canCancel: resale.podeCancelar ? 1 : 0,
    id: resale.id,
    cnpj: resale.cnpj,
    email: resale.email,
    fantasyName: resale.nomeFantasia,
    socialReason: resale.razaoSocial,
    photo: resale.logotipo,
    phone: resale.telefone,
    whatsAppPhone: resale.telefoneWhatsApp,
    ableToReceiveWhattsApp: resale.recebeMensagemWhatsApp,
    ableToReceiveNotificationWhatsApp: resale.recebeNotificacaoWhatsApp,
    isOpen: resale.estaAberta,
    cellPhone: resale.celular,
    password: "",
    area: paths,
    parameters: resale.parametrosOperacao
      .map(parameter => ({
        ...parameter,
        tipo: parameter.tipo !== 0 ? parameter.tipo : ProductTypesEnum.P13
      })),
    address: resale.endereco.endereco,
    number: resale.endereco.numero,
    cep: resale.endereco.cep,
    location: {
      lat: resale.latitude,
      lng: resale.longitude
    },
    multiBrand: resale.multimarca,
    termsAndConditions: resale.termosECondicoes,
    workSchedule: resale.escala.dias.map((x, index) => ({
      id: index,
      name: x.descricao,
      day: x.diaDaSemana,
      works: x.trabalha,
      start: x.inicio.substr(0, 5),
      end: x.fim.substr(0, 5),
      editing: false
    }))
  })
}

const apiRequestToFormOrganizationArea = organizationArea => {
  return organizationArea.map(resale => {
    let paths = []

    if (resale.area) {
      paths = resale.area.map(a => ({ "lat": a.latitude, "lng": a.longitude }));
    }

    return {
      ...resale,
      area: paths
    };
  })
}

export const get = (page, pageSize, filtro, termsAndConditions, aberta, ordenarData ) =>
  CancelablePromise(HttpService.AxiosClient.get(
    `${resource}\\${page}\\${pageSize}`,
    { params: { filtro, statusTermos: termsAndConditions, aberta, ordenarData } }))

export const getStatus = (page, pageSize, filter) =>
  CancelablePromise(HttpService.AxiosClient.get(`${resource}\\status\\${page}\\${pageSize}?filtro=${filter}`))

export const post = async value =>
  HttpService.AxiosClient.post(resource, await formToApiRequest(value))

export const update = async value =>
  HttpService.AxiosClient.put(resource, await formToApiRequest(value))

export const updateArea = (id, area) => {
  const mappedArea = area.map(({ lat, lng }) => ({ latitude: lat, longitude: lng }))
  return HttpService.AxiosClient.put(`${resource}/areaAtuacao`, { idRevenda: id, area: mappedArea })
}

export const find = id =>
  new Promise(async (resolve, reject) => {
    try {
      const result = await HttpService.AxiosClient.get(`${resource}\\${id}`)
      const resale = await apiRequestToForm(result);
      resolve(resale)
    } catch (error) {
      reject(error)
    }
  })

export const remove = id =>
  HttpService.AxiosClient.delete(`${resource}\\${id}`)

export const getTypesToDropDown = () =>
  HttpService.AxiosClient.get(`${resource}\\tiposproduto`)
    .then(result => result.map(type => ({ value: type.valor, text: type.descricao })))
    .catch(error => error)

export const getDropDownList = (organizationId = null) =>
  HttpService.AxiosClient.get(`${resource}/DropdownList`, { params: { idOrganizacao: organizationId }})

export const getDropDownListComMarca = (organizationId = null) =>
  HttpService.AxiosClient.get(`${resource}/DropdownListComMarca`, { params: { idOrganizacao: organizationId }})

export const autoComplete = ({ semOrganizacao, filtro }) =>
  HttpService.AxiosClient.get(`${resource}/autocomplete`, { params: { semOrganizacao, filtro } })
    .then(result => result)
    .catch(error => error)

export const areaWithouResale = () =>
  CancelablePromise(HttpService.AxiosClient.get(`vendedores\\locaissemvendedor`))

export const getConfiguration = () => HttpService.AxiosClient.get(`configuracoes`)

export const putClosedOpen = async ({isOpen, resaleId}) =>
  HttpService.AxiosClient.put(`${resource}\\abrirfechar`, { "estaAberta": isOpen, "idRevenda": resaleId })

export const changeMultiBrand = async ({ resaleId, multiBrand }) =>
  HttpService.AxiosClient.put(`${resource}/multimarca`, { idRevenda: resaleId, multimarca: multiBrand })

export const acceptTermsAndConditions = (resaleId) =>
  HttpService.AxiosClient.put(`${resource}/aceitarTermosECondicoes`, { idRevenda: resaleId })

export const declineTermsAndConditions = (resaleId) =>
  HttpService.AxiosClient.put(`${resource}/recusarTermosECondicoes`, { idRevenda: resaleId })

export const saveWhatsAppNumber = (resaleId, whatsAppNumber) =>
  HttpService.AxiosClient.put(`${resource}/whatsApp`, { idRevenda: resaleId, telefoneWhatsApp: whatsAppNumber })

export const updateAddress = (resaleId, address, cep, number) =>
  HttpService.AxiosClient.put(`${resource}/endereco`, { id: resaleId, endereco: address, cep: cep, numero: number })

export const getOrganizationArea = (resaleId) =>
  new Promise(async (resolve, reject) => {
    try {
      const result = await HttpService.AxiosClient.get(`${resource}/area-organizacao/${resaleId}`)
      const organizationArea = await apiRequestToFormOrganizationArea(result);
      resolve(organizationArea)
    } catch (error) {
      reject(error)
    }
  })
